
import { useEffect } from 'react';
import { useEngineStore } from '../stores/engine';
import { EngineCard } from './EngineCard';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Power, Activity } from 'lucide-react';

export const EngineMonitor = () => {
  const { 
    engines, 
    selectedEngineId, 
    realTimeData,
    criticalEngines,
    setEngines, 
    selectEngine, 
    toggleRealTimeData 
  } = useEngineStore();

  useEffect(() => {
    // 模拟初始数据加载
    const mockEngines = [
      {
        id: 'engine-1',
        name: '主发动机 #1',
        temperature: 85,
        rpm: 1800,
        fuel_consumption: 45.2,
        status: 'normal' as const,
      },
      {
        id: 'engine-2',
        name: '主发动机 #2',
        temperature: 92,
        rpm: 1750,
        fuel_consumption: 48.1,
        status: 'warning' as const,
      },
      {
        id: 'engine-3',
        name: '辅助发动机',
        temperature: 105,
        rpm: 2100,
        fuel_consumption: 52.8,
        status: 'critical' as const,
      },
    ];
    
    setEngines(mockEngines);
  }, [setEngines]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <h2 className="text-2xl font-bold">发动机监控</h2>
          {criticalEngines.length > 0 && (
            <Badge variant="destructive" className="animate-pulse">
              {criticalEngines.length} 紧急警报
            </Badge>
          )}
        </div>
        
        <div className="flex items-center space-x-2">
          <Button
            variant={realTimeData ? "default" : "outline"}
            size="sm"
            onClick={toggleRealTimeData}
            className="flex items-center space-x-2"
          >
            <Activity className="h-4 w-4" />
            <span>{realTimeData ? '实时监控中' : '启动实时监控'}</span>
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {engines.map((engine) => (
          <EngineCard
            key={engine.id}
            engine={engine}
            isSelected={selectedEngineId === engine.id}
            onClick={(engine) => selectEngine(engine.id)}
          />
        ))}
      </div>

      {engines.length === 0 && (
        <div className="text-center py-12">
          <Power className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">暂无发动机数据</p>
        </div>
      )}
    </div>
  );
};
